import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      /* eslint-disable global-require */
      translations: require('./locales/en/translations.json'),
    },
    es: {
      /* eslint-disable global-require */
      translations: require('./locales/es/translations.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    // React already escapes text when rendering - i18next's own HTML-entity
    // escaping (e.g. "/" -> "&#x2F;") would just show up as literal text.
    escapeValue: false,
  },
});

i18n.languages = ['en', 'es'];

export default i18n;
